import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import CallIcon from '@mui/icons-material/Call';
import SmsIcon from '@mui/icons-material/Sms';
import { SvgIconProps } from '@mui/material';
import { Action } from '../../api/gql';

export const ActionIcon = ({ action, ...rest }: { action: Action } & SvgIconProps) => {
  switch (action) {
    case Action.Email:
      return <AlternateEmailIcon {...rest} />;
    case Action.Sms:
      return <SmsIcon {...rest} />;
    case Action.Call:
      return <CallIcon {...rest} />;
    default:
      return null;
  }
};
